export const AUTH_CODES = {
    registerNewUser: 402,
    terminalNotConnected: 407
};

